import { Award, Heart, Users } from "lucide-react";

const COACH_IMG =
  "https://static.prod-images.emergentagent.com/jobs/10165ba5-237c-4471-8603-ea6dbde73886/images/4bdd2173bc61d56300e841bb7eef50405e44b5654a8da45eb57bd5916d642cfa.png";

const stats = [
  { icon: Users, value: "+10", label: "Años acompañando hombres" },
  { icon: Award, value: "120+", label: "Transformaciones reales" },
  { icon: Heart, value: "1:1", label: "Trato cercano y humano" },
];

export const SobreAitor = () => {
  return (
    <section
      id="aitor"
      data-testid="section-aitor"
      className="relative bg-[#0F0F0F] py-24 sm:py-32 border-t border-zinc-900 overflow-hidden"
    >
      <div className="w-full max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 grid lg:grid-cols-12 gap-12 items-center">
        {/* Image side */}
        <div className="lg:col-span-5 relative">
          <div className="absolute -top-4 -left-4 right-8 bottom-8 border-2 border-[#FF5A1F]/40 z-0" />
          <div className="relative grain overflow-hidden border border-zinc-800">
            <img
              src={COACH_IMG}
              alt="Aitor, nutricionista y entrenador en Pamplona"
              className="w-full h-[560px] object-cover"
              data-testid="aitor-image"
            />
            <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-black to-transparent h-1/3" />
            <div className="absolute bottom-6 left-6">
              <p className="font-display uppercase text-3xl font-black text-white tracking-tight">
                Aitor
              </p>
              <p className="text-xs uppercase tracking-widest text-[#FF5A1F] mt-1">
                Tu coach en Pamplona
              </p>
            </div>
          </div>
        </div>

        {/* Text side */}
        <div className="lg:col-span-7">
          <p className="text-xs sm:text-sm text-[#FF5A1F] uppercase tracking-[0.25em] font-bold mb-6">
            04 — Sobre Aitor
          </p>
          <h2
            data-testid="aitor-heading"
            className="font-display font-black uppercase text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tighter"
          >
            No soy un gurú.
            <br />
            <span className="text-zinc-500">Soy el tipo que te hace cumplir.</span>
          </h2>

          <div className="mt-8 space-y-5 text-zinc-300 text-lg leading-relaxed max-w-2xl">
            <p>
              Llevo más de 10 años trabajando con hombres que, como tú, llegan
              cansados, frustrados y con la sensación de haberlo intentado todo.
              Mi trabajo no es darte otra dieta más: es darte un{" "}
              <span className="text-white font-semibold">proceso real</span>{" "}
              adaptado a tu vida.
            </p>
            <p>
              Trabajo en C/ Berriobide, en Pamplona, y también online con
              clientes de toda España. Hablo claro, exijo lo justo y celebro
              cada kilo, cada talla y cada victoria contigo.
            </p>
            <p className="text-white font-semibold">
              Si estás listo para el CAMBIO, yo estoy listo para acompañarte.
            </p>
          </div>

          <div className="mt-10 grid sm:grid-cols-3 gap-4">
            {stats.map((s) => {
              const Icon = s.icon;
              return (
                <div
                  key={s.label}
                  className="bg-zinc-950 border border-zinc-800 p-5"
                >
                  <Icon size={20} className="text-[#FF5A1F]" />
                  <p className="font-display font-black text-3xl text-white mt-3">
                    {s.value}
                  </p>
                  <p className="text-xs uppercase tracking-widest text-zinc-500 mt-1">
                    {s.label}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
